export const environment = {
    production: false,
    identityUrl: 'https://identity-v2-dev.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://forms-v3-dev.nside.io',
    apiBaseUrl: 'https://v3-api-dev.nside.io',
};
  